namespace $.$$ {

	const { hsla } = $mol_style_func
	
	$mol_style_define( $shm_hitalama_app_book, {
		
		Maps_list_toggle: {
			flex: {
				shrink: 0,
				grow: 0,
			},
		},

		Menu: {
			Body_content: {
				height: '100%',
			},
		},

		Foot_profile_card: {
			align: {
				items: 'center',
			},
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
			// box: {
			// 	shadow: [
			// 		[ 0, 0, 0, '1px', $mol_theme.line ],
			// 		[ 0, '0.25rem', '1rem', 0, hsla( 0, 0, 0, .08 ) ],
			// 	],
			// },
			box: {
				shadow: [
					[ 0, `-0.5rem`, `0.5rem`, `-0.5rem`, hsla( 0, 0, 0, .25 ) ],
					[ 0, `0.5rem`, `0.5rem`, `-0.5rem`, hsla( 0, 0, 0, .25 ) ],
				],
			},
			gap: '0.75rem',
			margin: {
				top: 'auto',
				left: '-0.75rem',
				right: '-0.75rem',
				bottom: '-0.75rem',
			},
			padding: '0.75rem',
		},

		// Foot_avatar: {
		// 	flex: {
		// 		shrink: 0,
		// 	},
		// 	width: '2rem',
		// 	height: '2rem',
		// },

		Foot_profile: {
			flex: {
				grow: 1,
			},
			// gap: '0.25rem',

			Login: {
				justify: {
					content: 'center',
				},
				flex: {
					grow: 1,
				},
			},

			Enter_link: {
				align: {
					items: 'center',
				},
			},

			Register_link: {
				align: {
					items: 'center',
				},
			},
		},
		
	} )
	
}
